import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Form, FormGroup, FormControl } from 'react-bootstrap';
import actions from '../../redux/actions';
import Heading from '../Heading';
import NavButtons from '../NavButtons';

class MultipleWorkType extends Component {
  handleTitleType(e, key) {
    const { fields } = this.props;

    let titleTypes = fields.titleTypes || {};
    titleTypes[key] = e.target.value;

    this.props.assignAttribute('titleTypes', {
      ...titleTypes,
      workType: 'multiple',
    });
  }

  handleNext() {
    const { fields } = this.props;

    this.props.hideAlert();
    let checked = false;

    if (
      fields.titleTypes &&
      fields.titleTypes.largerWork &&
      fields.titleTypes.largerWork !== ''
    ) {
      checked = true;
    }

    if (checked) {
      this.props.router.push('/copyright-reg/publish');
    } else {
      this.props.alert('error', 'Please check the required fields.');
    }
  }

  render() {
    const { fields } = this.props;
    const titleTypes = fields.titleTypes || {};

    return (
      <div className="select-work work-title">
        <Heading text="Tell Us More About This Collection" />
        <div className="content">
          <Form>
            <FormGroup>
              <ul>
                <li>
                  <div>
                    <span className="text-red">*&nbsp;</span>What is the name of
                    your collection (for example, the title of an album of
                    music)?
                  </div>
                  <FormControl
                    type="text"
                    value={titleTypes.largerWork || ''}
                    onChange={(e) => this.handleTitleType(e, 'largerWork')}
                    placeholder="Type Here"
                  />
                </li>
                <li>
                  <div>
                    If this collection is part of a series, what is the series
                    title?
                  </div>
                  <FormControl
                    type="text"
                    value={titleTypes.series || ''}
                    onChange={(e) => this.handleTitleType(e, 'series')}
                    placeholder="Type Here"
                  />
                </li>
                <li>
                  <div>
                    If this collection has a previous/alternate title, what was
                    it?
                  </div>
                  <FormControl
                    type="text"
                    value={titleTypes.previousAlt || ''}
                    onChange={(e) => this.handleTitleType(e, 'previousAlt')}
                    placeholder="Type Here"
                  />
                </li>
              </ul>
            </FormGroup>
          </Form>
        </div>
        <div className="step-nav">
          <NavButtons
            direction="back"
            prev={() => this.props.router.push('/copyright-reg/multiple-work')}
          />
          <NavButtons direction="next" next={() => this.handleNext()} />
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  fields: state.coreg.fields,
});

const mapDispatchToProps = (dispatch) => ({
  alert: (type, msg) => {
    dispatch(actions.alert(type, msg));
  },
  hideAlert: () => {
    dispatch(actions.hideAlert());
  },
  assignAttribute: (field, attribute) => {
    dispatch(actions.assignCoregAttribute(field, attribute));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(MultipleWorkType);



// WEBPACK FOOTER //
// src/components/Copyright/MultipleWorkType.jsx